import {
  LoadingController,
  NavController,
  ToastController,
  ModalController,
} from "@ionic/angular";
import { MenuController } from "@ionic/angular";
import { Injectable } from "@angular/core";
import { GlobalProvider } from "src/services/global";
// import { Storage } from "@ionic/storage";
import { NavigationExtras } from "@angular/router";
import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
import { Preferences } from "@capacitor/preferences";
// import { AuditLogComponent } from './components/auditLog/auditLog.component';
// import { ChatService } from 'src/services/chat.service';

@Injectable({
  providedIn: "root",
})
export class BaseHelper {
  gLoading;
  constructor(
    protected loadingCtrl: LoadingController,
    protected toastController: ToastController,
    protected modal: ModalController,
    protected navCtrl: NavController,
    protected g: GlobalProvider,
    protected menu: MenuController,
    // protected storage: Storage,
    private iab: InAppBrowser // private cs: ChatService
  ) {
    this.initLoadLoading();
  }
  menuOpen() {
    console.log(`menuopen`);
    this.menu.enable(true);
  }
  menuClose() {
    this.menu.enable(false);
  }

  openTab(url) {
    this.iab.create(url, "_blank");
  }
  // async audit(docType, docId) {
  //   const modal = await this.modal.create({
  //     component: AuditLogComponent,
  //     cssClass: 'big-modal',
  //     componentProps: {
  //       docType,
  //       docId,
  //     },
  //   });
  //   modal.onDidDismiss().then(async (obj) => {});
  //   await modal.present();
  // }
  async docShare(docType, docId) {}
  async toast(message, duration = 1000, color = `success`) {
    const toast = await this.toastController.create({
      message,
      duration,
      color,
      buttons: [
        {
          icon: "close",
          role: "cancel",
          // handler: () => {
          //   console.log('Cancel clicked');
          // },
        },
      ],
    });
    toast.present();
  }
  async initLoadLoading(duration = 5000) {
    this.gLoading = await this.loadingCtrl.create({
      message: "Please Wait...",
      duration,
    });
  }
  // async loadLoading(toggle = true, duration = 5000) {
  //   if (toggle) {
  //     if (!this.gLoading) {
  //       await this.initLoadLoading(duration);
  //     }
  //     this.gLoading.present();
  //   } else {
  //     if (this.gLoading) {
  //       await this.gLoading.dismiss();
  //     }

  //     this.initLoadLoading();
  //   }
  //   return;
  // }

  async loadLoading(toggle = true, duration = 5000) {
    if (toggle) {
      if (!this.gLoading) {
        await this.initLoadLoading(duration);
      } else {
        // had to put else condition coz for some reason, its taking 5000 instead of passed argument.
        await this.gLoading.dismiss();
        await this.initLoadLoading(duration);
      }
      this.gLoading.present();
    } else {
      if (this.gLoading) {
        await this.gLoading.dismiss();
      }

      this.initLoadLoading(duration);
    }
    return;
  }

  async setStorage(key, value) {
    // await this.storage.set(key, value);
    await Preferences.set({
      key,
      value: JSON.stringify(value),
    });
  }
  async getStorage(key) {
    // return await this.storage.get(key);
    const ret = await Preferences.get({ key });
    return JSON.parse(ret.value);
  }

  setJws(tokenObj, profile) {
    console.log(`profile`, profile);
    this.setStorage("companyToken", tokenObj);
    this.g.jws = tokenObj.token;
    this.g.profile = profile;
    this.g.profileType = tokenObj.profileType;
    this.g.role = profile.role;
    // this.g.accessRole = profile.role;
    // this.g.mediaUrl = mediaUrl;
  }
  async clearJws() {
    this.setStorage("companyToken", null);
    this.g.jws = null;
    this.g.profile = null;
    this.g.profileType = null;
    this.g.companyName = null;
    this.g.notifications = [];
    this.g.accessRole = null;
    this.g.role = null;
    this.g.auditLogAllow = false;
    this.g.docShareAllow = false;
    this.g.mediaUrl = null;
  }
  async getJws() {
    return await this.getStorage("companyToken");
  }
  navigateRoot(path, queryParams = null) {
    if (queryParams) {
      const navigationExtras: NavigationExtras = {
        queryParams,
      };
      this.navCtrl.navigateRoot(path, navigationExtras);
    } else {
      this.navCtrl.navigateRoot(path);
    }
  }
  navigate(path) {
    this.navCtrl.navigateForward(path);
  }

  pop() {
    this.navCtrl.pop();
  }

  async danger(message, duration = 300) {
    const toast = await this.toastController.create({
      message,
      duration,
      color: "danger",
      buttons: [
        {
          icon: "close",
          role: "cancel",
          // handler: () => {
          //   console.log('Cancel clicked');
          // },
        },
      ],
    });
    toast.present();
  }
  add(a, b, decimalPoints) {
    return Number((Number(a) + Number(b)).toFixed(decimalPoints));
  }
  copy(str) {
    const el = document.createElement("textarea");
    el.value = str;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    this.toast(`copied ${str}`);
  }

  convert(value) {
    value = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "SGD",
      // currencySign: "accounting",
      // signDisplay: "always",
    }).format(value);
    console.log("check converted value?", value);
    return value;
  }

  filterAvail(propertiesName, json) {
    const objectConstructor = {}.constructor;

    const data = {};
    Object.entries(json).map(([key, value]) => {
      let v2 = value;
      if (propertiesName.includes(key)) {
        if (!v2 || v2 === false || v2 === 0) {
        } else if (v2.constructor === objectConstructor) {
          v2 = JSON.stringify(v2);
        } else {
          if (!v2) v2 = null;
        }
        data[key] = v2;
      }
    });
    return data;
  }
}
